import { DateOnlyInput } from "../components/DateOnlyInput";
import { useEffect, useRef, useState } from "react";
import { getRuntimeConfig } from "../auth";
import { alphaMutationRejected } from "../alpha-mutation";
export function SupplierInvoicesAlpha({
  reference,
  files,
  request,
}: {
  reference: string;
  files: { reference: string; title: string }[];
  request: (path: string, body?: unknown) => Promise<any>;
}) {
  const [items, setItems] = useState<any[]>(),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false),
    [unavailable, setUnavailable] = useState(false);
  const pending = useRef<any>(null),
    path = "/jobs/" + reference + "/invoices";
  const load = () => request(path).then((r) => setItems(r.invoices));
  useEffect(() => {
    void getRuntimeConfig()
      .then((config) => {
        if (!config.alphaFeaturesEnabled) {
          setUnavailable(true);
          return;
        }
        return load();
      })
      .catch((e) => setError((e as Error).message));
  }, [reference]);
  async function send(body: any) {
    pending.current ??= { ...body, requestKey: crypto.randomUUID() };
    setBusy(true);
    try {
      await request(path, pending.current);
      pending.current = null;
      setError("");
      await load();
    } catch (e) {
      if (alphaMutationRejected(e)) pending.current = null;
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  if (unavailable) return null;
  return (
    <section>
      <h4>Invoices and payment updates</h4>
      {error && <p role="alert">{error}</p>}
      {pending.current && !busy && (
        <button onClick={() => void send({})}>Retry the same invoice</button>
      )}
      {items?.map((i) => (
        <p key={i.reference}>
          {i.invoice_number} · £{i.gross_amount} · {i.status} · Recorded
          settlement £{i.settled}
        </p>
      ))}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          void send({
            documentReference: f.get("document"),
            invoiceNumber: f.get("number"),
            invoiceDate: f.get("date"),
            net: f.get("net"),
            vat: f.get("vat"),
            gross: f.get("gross"),
          });
        }}
      >
        <fieldset disabled={busy || !!pending.current}>
          <legend>Submit an invoice</legend>
          <p>
            Upload your invoice as job evidence above, then select it here.
            Submission starts staff review; payment is a separate decision.
          </p>
          <label>
            Uploaded invoice
            <select name="document" required>
              <option value="">Choose invoice</option>
              {files.map((f) => (
                <option key={f.reference} value={f.reference}>
                  {f.title}
                </option>
              ))}
            </select>
          </label>
          <label>
            Invoice number
            <input name="number" required maxLength={100} />
          </label>
          <label>
            Invoice date
            <DateOnlyInput name="date" required />
          </label>
          {["net", "vat", "gross"].map((n) => (
            <label key={n}>
              {n === "vat"
                ? "VAT"
                : n === "net"
                  ? "Net amount"
                  : "Total including VAT"}
              <input
                name={n}
                inputMode="decimal"
                required
                pattern="[0-9]+(\.[0-9]{1,2})?"
              />
            </label>
          ))}
          <button>Submit for review</button>
        </fieldset>
      </form>
    </section>
  );
}
